import { trackPage } from "../../../../../../services/analytics";

export const initialised = state => {
  trackPage({ state });

  return state;
};
